import { ReactComponent as IconCsv } from '@/assets/svgs/csv-large.svg'
import { ReactComponent as IconEclip } from '@/assets/svgs/eclip-large.svg'
import useConfig from '@/hooks/use-config/index.js'
import usePage from '@/hooks/use-page/index.js'
import useTemplates from '@/hooks/use-templates/index'
import { useEffect } from 'react'
import CsvTemplateCard from './csv-template-card.jsx'
import TemplateCard from './template-card.jsx'

export default function Templates() {
	const { items: templateList, fetch: getAllTemplates } = useTemplates()
	const { provideItems } = useConfig()
	const { breadcrumbsItems } = usePage({
		title: 'Templates',
		breadcrumbs: [
			'Package Sharing',
		],
	})

	useEffect(() => {
		getAllTemplates()
	}, [])

	return (
		<div>
			<div className="eclip-landing__sub-heading">Package Templates</div>

			<div>
				{templateList?.length > 0 ? (
					<div className="eclip-landing-folder--wrapper">
						{templateList?.map((item, index) => {
							return <TemplateCard key={index} item={item} />
						})}
					</div>
				) : (
					<div className="data-table__table__body">
						<div className="data-table__empty">
							<div className="data-table__empty__icon">
								<IconEclip />
								No Templates Found
							</div>
						</div>
					</div>
				)}
			</div>

			<div className="eclip-landing__sub-heading">
				Data Element CSV Templates
			</div>

			<div>
				{provideItems?.length > 0 ? (
					<div className="csv-templates__list">
						{provideItems?.map((item, index) => {
							return <CsvTemplateCard key={index} item={item} />
						})}
					</div>
				) : (
					<div className="data-table__table__body">
						<div className="data-table__empty">
							<div className="data-table__empty__icon">
								<IconCsv />
								Coming Soon
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	)
}
